module.exports = __webpack_public_path__ + "img/dodAddPlusIcon.cadc81e8.svg";